module.exports = __webpack_public_path__ + "static/tree_front-a4ea6b163265cb5c9605bb69a9a73b64.png";